import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3342eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MCheckbox field-checkbox",
  "data-testid": "checkbox"
}
const _hoisted_2 = ["for"]

import Checkbox from "primevue/checkbox"
  import { computed, WritableComputedRef } from "vue"
  import type { ModelValue } from "./MCheckbox.modelos"

  interface CheckboxProps {
    binary?: boolean
    id?: string
    nome: string
    modelValue: ModelValue
    valor?: ModelValue
    label?: string
    limiteDeCaracteresDaLegenda?: number
    dataTestid?: string
    habilitarDica?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MCheckbox',
  props: {
    binary: { type: Boolean },
    id: null,
    nome: null,
    modelValue: null,
    valor: null,
    label: null,
    limiteDeCaracteresDaLegenda: null,
    dataTestid: null,
    habilitarDica: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: "update:modelValue", modelValue: ModelValue): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    binary?: boolean
    id?: string
    nome: string
    modelValue: ModelValue
    valor?: ModelValue
    label?: string
    limiteDeCaracteresDaLegenda?: number
    dataTestid?: string
    habilitarDica?: boolean
  }

  

  

  const limitarTamanhoLabel = computed(() => {
    if (props.label) {
      return props.limiteDeCaracteresDaLegenda &&
        props.label?.length > props.limiteDeCaracteresDaLegenda
        ? props.label?.slice(0, props.limiteDeCaracteresDaLegenda) + "..."
        : props.label
    } else {
      return ""
    }
  })

  const dica = computed(() => {
    return {
      value: props.label,
      disabled: !props.habilitarDica,
    }
  })

  const emitirModel: WritableComputedRef<ModelValue> = computed({
    get(): ModelValue {
      return props.modelValue
    },
    set(value: ModelValue) {
      emits("update:modelValue", value)
    },
  })

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Checkbox), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      binary: __props.binary,
      class: "MCheckbox__Checkbox",
      "data-testid": __props.dataTestid,
      "input-id": __props.id,
      name: __props.nome,
      value: __props.valor
    }, null, 8, ["modelValue", "binary", "data-testid", "input-id", "name", "value"]),
    (__props.label)
      ? _withDirectives((_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "small-text",
          for: __props.id
        }, [
          _createTextVNode(_toDisplayString(_unref(limitarTamanhoLabel)), 1)
        ], 8, _hoisted_2)), [
          [_directive_tooltip, _unref(dica)]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})